import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { JPH_APP_BUILD_LABEL } from '@/lib/appBuild'

// Visible in production console to confirm deployed commit/build.
// eslint-disable-next-line no-console
console.info(`[JPH Portal] build=${JPH_APP_BUILD_LABEL}`)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
